module.exports = __webpack_public_path__ + "img/koshyk.f957fbdd.png";